<template>
  <router-view />
  <BaseModal
    :show="modal.show"
    :type="modal.type"
    :message="modal.message"
    :onConfirm="modal.onConfirm"
    @close="closeModal"
  />
</template>

<script setup>

import BaseModal from '@/components/BaseModal.vue'
import { onMounted,computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const modal = computed(() => store.getters['ui/modal'])
const closeModal = () => {
  store.commit('ui/HIDE_MODAL')
}

const isAuthenticated = computed(() => store.getters['auth/isAuthenticated'])

onMounted( () => {
  if (isAuthenticated.value) {
    store.dispatch('users/getProfile')
    store.dispatch('settings/fetchBranding')
  }
  setTimeout(() => {
    closeModal()
  },3000)
})
</script>
